import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  menuIcon: {
    width: 22,
    height: 22,
  },
  menuIconAdd: {
    width: 14,
    height: 14,
    padding: 2,
  },
});
